import React from 'react';
import { ApolloProvider as ApolloClientProvider } from '@apollo/client/react';

import apolloClient from '../api/apolloClient';

interface Props {
  children: React.ReactNode;
}

const ApolloProvider: React.FC<Props> = ({ children }) => (
  <ApolloClientProvider client={apolloClient}>{children}</ApolloClientProvider>
);

export default ApolloProvider;

